import _ from 'underscore';

import { LocationGroupDesignation } from '@biteinc/enums';

app.UserSelectorListView = app.ModelSelectorListView.extend({
  getListSections() {
    const users = this.collection.models;
    const [orgWide, allLive] = _.partition(users, (user) => {
      return user.get('designation') === LocationGroupDesignation.OrgWide;
    });

    return _.compact([
      orgWide.length && {
        header: 'Users on all locations',
        models: orgWide,
        allowAllToBeSelected: true,
      },
      allLive.length && {
        header: 'Users on all live locations',
        models: allLive,
        allowAllToBeSelected: true,
      },
    ]);
  },
});
